import React from 'react';
import { withAuthDomain } from '../../components/Session';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import {Grid, Paper, Typography } from '@material-ui/core';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import StarIcon from '@material-ui/icons/StarBorder';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Divider from '@material-ui/core/Divider';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';

import Switch from '@material-ui/core/Switch';
import WifiIcon from '@material-ui/icons/Wifi';

import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import BuildIcon from '@material-ui/icons/Build';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';

const useStyles = makeStyles(theme => ({
  root: {
    overscrollBehavior: "contain",
    maxWidth:"100vw",
    minHeight:"89vh",
    overflow:"auto",
    margin:"0px",
    padding:"0px",
    paddingBottom:"70px",
    position:"relative",
    userSelect:"none", 
  },
  paper:{
    margin:"10px",
    padding:"20px",
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
}));

const BranchSettingsPage = (props) => {
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    
    width,
    currentDate,
    serverMillis,
    serverClockStatus,
    activeCompany,
    
    //...otherProps
  }=props
  const classes = useStyles();
  const [branchList,setBranchList]=React.useState([])
  const [activeBranch,setActiveBranch]=React.useState()
  const [activeBranchId,setActiveBranchId]=React.useState(!!activeCompany?activeCompany.id:"")

  const [editBranchInformation,setEditBranchInformation]=React.useState(false)
  const [savingBranchInformation,setSavingBranchInformation]=React.useState(false)

  const [financeConfig,setFinanceConfig]=React.useState()
  const [marketConfig,setMarketConfig]=React.useState()
  const [productionConfig,setProductionConfig]=React.useState()
  const [workshopConfig,setWorkshopConfig]=React.useState()
  const [restaurantConfig,setRestaurantConfig]=React.useState()
  

  React.useEffect(()=>{
    setBranchList([])
    setActiveBranch(null)
    setActiveBranchId(!!activeCompany?activeCompany.id:"")
    setEditBranchInformation(false)
    setSavingBranchInformation(false)
    setFinanceConfig(null)
    setMarketConfig(null)
    setProductionConfig(null)
    setWorkshopConfig(null)
    setRestaurantConfig(null)
    if(!!activeCompany){
      return firebase.fs.collection("companies/"+activeCompany.id+"/branches").onSnapshot((querySnapshot) => {
        var branches = [];
        querySnapshot.forEach(function(doc) {
          branches.push(doc.data());
        });
        setBranchList(branches)
      },(e)=>{
        console.log("error get branch list"+e)
      })
    }else{
      setBranchList([])
    }
  },[activeCompany])

  React.useEffect(()=>{
    if(!!activeCompany&&!!activeCompany.id&&activeBranchId){
      return firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranchId).onSnapshot((doc) => {
        setActiveBranch(doc.data())
      },(e)=>{
        setActiveBranch(null)
        console.log("error get branch : "+e)
      })
    }else{
      setActiveBranch(null)
    }
  },[activeCompany,activeBranchId])

  React.useEffect(()=>{
    revertBranchInformation()
  },[activeCompany,activeBranch])

  React.useEffect(()=>{
    setFinanceConfig(null)
    if(!activeCompany||!activeBranch)return
    return firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id+"/features/finance").onSnapshot((doc) => {
      setFinanceConfig(doc.data())
    },(e)=>{
      setFinanceConfig(null)
      console.log("error get FinanceConfig : "+e)
    })
  },[activeCompany,activeBranch])

  React.useEffect(()=>{
    setProductionConfig(null)
    if(!activeCompany||!activeBranch)return
    return firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id+"/features/production").onSnapshot((doc) => {
      setProductionConfig(doc.data())
    },(e)=>{
      setProductionConfig(null)
      console.log("error get ProductionConfig : "+e)
    })
  },[activeCompany,activeBranch])

  React.useEffect(()=>{
    setMarketConfig(null)
    if(!activeCompany||!activeBranch)return
    return firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id+"/features/market").onSnapshot((doc) => {
      setMarketConfig(doc.data())
    },(e)=>{
      setMarketConfig(null)
      console.log("error get MarketConfig : "+e)
    })
  },[activeCompany,activeBranch])

  

  function addNewBranch(){
    if(!activeCompany)return
    var branchRef=firebase.fs.collection("companies/"+activeCompany.id+"/branches").doc()

    var branchObj={
      id:branchRef.id,
      type:activeCompany.type,
      name:activeCompany.name+" Cabang "+(branchList.length+1),
      address:"",
      town:"",
      phone:"",
      email:"",
      NPWP:"",
      owner:currentUser.id,
      deactivated:false,
      companyId:activeCompany.id,
    }

    var batch = firebase.fs.batch();
    batch.set(branchRef, branchObj);
    batch.commit().then(()=>{
      setActiveBranchId(branchObj.id)
    }).catch(e=>{
      alert("Gagal membuat cabang : "+e)
    })
  }
  
  function saveBranchInformation(){
    if(!activeCompany||!activeBranch)return
    var dbranchName,dbranchAddress,dbranchTown,dbranchPhone,dbranchEmail,dbranchNPWP
    var branchName,branchAddress,branchTown,branchPhone,branchEmail,branchNPWP
    
    dbranchName=document.getElementById("branchName")
    dbranchAddress=document.getElementById("branchAddress")
    dbranchTown=document.getElementById("branchTown")
    dbranchPhone=document.getElementById("branchPhone")
    dbranchEmail=document.getElementById("branchEmail")
    dbranchNPWP=document.getElementById("branchNPWP")

    branchName=dbranchName.value
    branchAddress=dbranchAddress.value
    branchTown=dbranchTown.value
    branchPhone=dbranchPhone.value
    branchEmail=dbranchEmail.value
    branchNPWP=dbranchNPWP.value
    
    if(!branchName ||!branchAddress ||!branchTown ||!branchPhone ||!branchEmail){
      alert("Mohon lengkapi data")
      return
    }
    
    var branchObj={
      name:branchName,
      address:branchAddress,
      town:branchTown,
      phone:branchPhone,
      email:branchEmail,
      NPWP:branchNPWP,
    }
    setSavingBranchInformation(true)
    firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id).set(
      branchObj,{merge:true}
    ).then(()=>{
      setSavingBranchInformation(false)
      setEditBranchInformation(false)
    }).catch(e=>{
      alert("Gagal menyimpan perusahaan : "+e)
      setSavingBranchInformation(false)
    })
  }

  function revertBranchInformation(){
    if(!!activeBranch){
      var dbranchName,dbranchAddress,dbranchTown,dbranchPhone,dbranchEmail,dbranchNPWP
      
      dbranchName=document.getElementById("branchName")
      dbranchAddress=document.getElementById("branchAddress")
      dbranchTown=document.getElementById("branchTown")
      dbranchPhone=document.getElementById("branchPhone")
      dbranchEmail=document.getElementById("branchEmail")
      dbranchNPWP=document.getElementById("branchNPWP")

      if(!!dbranchName)dbranchName.value=activeBranch.name||""
      if(!!dbranchAddress)dbranchAddress.value=activeBranch.address||""
      if(!!dbranchTown)dbranchTown.value=activeBranch.town||""
      if(!!dbranchPhone)dbranchPhone.value=activeBranch.phone||""
      if(!!dbranchEmail)dbranchEmail.value=activeBranch.email||""
      if(!!dbranchNPWP)dbranchNPWP.value=activeBranch.NPWP||""
    }
    setEditBranchInformation(false)
  }

  function toggleFinanceFeature(){
    if(!!financeConfig&&financeConfig.enabled){
      //deactivation
      if((!!marketConfig&&marketConfig.enabled)||(!!productionConfig&&productionConfig.enabled)||
      (!!workshopConfig&&workshopConfig.enabled)||(!!restaurantConfig&&restaurantConfig.enabled)){
        var res=window.confirm("Dengan menon-aktifkan fitur Finance, Anda juga akan menon-aktifkan fitur Market dan "+activeCompany.type+"\nApakah Anda Yakin untuk melanjutkannya?")
        if(!res)return
        if(!!marketConfig&&marketConfig.enabled)toggleMarketFeature()
        if(!!productionConfig&&productionConfig.enabled)toggleProductionFeature()
        if(!!workshopConfig&&workshopConfig.enabled)toggleWorkshopFeature()
        if(!!restaurantConfig&&restaurantConfig.enabled)toggleRestaurantFeature()
      }
      firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id+"/features/finance").set(
      {enabled:false},{merge:true}).then()
      .catch(e=>{
        alert("Gagal deaktivasi fitur : " +e)
      })
    }else{
      if(!!financeConfig){
        //activation
        firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id+"/features/finance").set(
        {enabled:true},{merge:true}).then()
        .catch(e=>{
          alert("Gagal aktivasi fitur : " +e)
        })
      }else{
        //initialisation
      firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id+"/features/finance").set(
        {
          enabled:true,
          cashboxList:[
            {id:"kas",
              name:"Kas",
              type:"AKTIVA LANCAR",
              lastValue:0,
              lastCalculated:"0",
            },
            {id:"bankBCA",
              name:"Bank BCA",
              type:"AKTIVA LANCAR",
              lastValue:0,
              lastCalculated:"0",
            },
            {id:"bankBNI",
              name:"Bank BNI",
              type:"AKTIVA LANCAR",
              lastValue:0,
              lastCalculated:"0",
            },
            {id:"nilaiTanah",
              name:"Nilai Tanah",
              type:"AKTIVA TETAP",
              lastValue:0,
              lastCalculated:"0",
            },
            {id:"nilaiBangunan",
              name:"Nilai Bangunan",
              type:"AKTIVA TETAP",
              lastValue:0,
              lastCalculated:"0",
            },
            {id:"nilaiPeralatan",
              name:"Nilai Peralatan",
              type:"AKTIVA TETAP",
              lastValue:0,
              lastCalculated:"0",
            },
            {id:"nilaiKendaraan",
              name:"Nilai Kendaraan",
              type:"AKTIVA TETAP",
              lastValue:0,
              lastCalculated:"0",
            },
          ],
          incomeCategoryList:[
            "Pendapatan","Penjualan Barang","Retur Pembelian","Penyesuaian Rugi/Laba","Potongan Pembelian","Suntikan Modal","Mutasi Saldo"
          ],
          expenseCategoryList:[
            "Biaya Air","Biaya Listrik","Biaya Telepon","Biaya Wifi","Biaya Gaji Karyawan","Biaya Depresiasi Peralatan","Biaya Makan & Minum",
            "Biaya Perlengkapan","Biaya Sewa Tempat Usaha","Biaya Pengiriman","Pembelian Barang","Retur Penjualan",
            "Biaya Umum Lain-Lain","Mutasi Hutang"
          ],
        }
        ,{merge:true}).then()
        .catch(e=>{
          alert("Gagal inisialisasi fitur : " +e)
        })
      }
    }
  }

  function toggleMarketFeature(){
    if(!!marketConfig&&marketConfig.enabled){
      //deactivation
      if((!!productionConfig&&productionConfig.enabled)||
      (!!workshopConfig&&workshopConfig.enabled)||(!!restaurantConfig&&restaurantConfig.enabled)){
        var res=window.confirm("Dengan menon-aktifkan fitur Market, Anda juga akan menon-aktifkan fitur "+activeCompany.type+"\nApakah Anda Yakin untuk melanjutkannya?")
        if(!res)return
        if(!!productionConfig&&productionConfig.enabled)toggleProductionFeature()
        if(!!workshopConfig&&workshopConfig.enabled)toggleWorkshopFeature()
        if(!!restaurantConfig&&restaurantConfig.enabled)toggleRestaurantFeature()
      }
      firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id+"/features/market").set(
        {enabled:false},{merge:true}).then()
        .catch(e=>{
          alert("Gagal deaktivasi fitur : " +e)
        })
    }else{
      if(!!marketConfig){
        //activation
        firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id+"/features/market").set(
        {enabled:true},{merge:true}).then()
        .catch(e=>{
          alert("Gagal aktivasi fitur : " +e)
        })
      }else{
        //initialisation
        firebase.fs.doc("companies/"+activeCompany.id+"/branches/"+activeBranch.id+"/features/market").set(
        {
          enabled:true,
          productCategoryList:[
            "JASA",
            "Bahan Baku",
            "Barang Dijual",
          ],
        }
        ,{merge:true}).then()
        .catch(e=>{
          alert("Gagal inisialisasi fitur : " +e)
        })
      }
    }
  }
  
  function toggleProductionFeature(){
    if(!!productionConfig&&productionConfig.enabled){
      //deactivation
    }else{
      if(!!productionConfig){
        //activation
      }else{
        //initialisation
      }
    }
  }
  
  function toggleWorkshopFeature(){
    if(!!workshopConfig&&workshopConfig.enabled){
      //deactivation
    }else{
      if(!!workshopConfig){
        //activation
      }else{
        //initialisation
      }
    }
  }
  
  function toggleRestaurantFeature(){
    if(!!restaurantConfig&&restaurantConfig.enabled){
      //deactivation
    }else{
      if(!!restaurantConfig){
        //activation
      }else{
        //initialisation
      }
    }
  }
  
  function toogleBranchEnabled(company,branch){
    var pr=""
    if(!branch.deactivated){
      pr=window.prompt("Apakah Anda yakin untuk menon-aktifkan "+branch.name+"?\n\nMasukkan '"+branch.name+"' untuk melanjutkan.")
      if(!pr){
        return
      }else if(pr!==branch.name){
        alert("Kode tidak sesuai")
        return
      }
    }

    firebase.fs.doc("companies/"+company.id+"/branches/"+branch.id).set({
      deactivated:!branch.deactivated
    },{merge:true}).then().catch(e=>{
      alert("Gagal : "+e)
    })
  }

  

  return (
    <div className={classes.root}>
      {sessionDomain>=1&&!!activeCompany&&!!activeBranch&&
        <Grid container direction={width==="xs"?"column":"row"} justify={width==="xs"?"center":"flex-start"} alignItems={width==="xs"?"stretch":"flex-start"}>
          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"100px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                  Kantor Cabang{width==="xs"?<br/>:null}
                  <Button style={{float:"right"}} variant="contained" color="primary" onClick={addNewBranch}>Tambah</Button>
              </Typography>
              <FormControl fullWidth style={{margin:"5px"}}>
                <InputLabel id="branchTypeLabel">{!activeBranchId?"Pilih Cabang":""}</InputLabel>
                <Select
                  labelId="branchTypeLabel"
                  value={activeBranchId}
                  onChange={(ev)=>{setActiveBranchId(ev.target.value)}}
                >
                  {branchList.map((branch,idx)=><MenuItem value={branch.id} key={branch.id||idx}>{branch.name}{(!!activeCompany&&activeCompany.id===branch.id)&&" (Cabang Pusat)"}</MenuItem>)}
                </Select>
              </FormControl>
            </Paper>
          </Grid>

          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"300px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Informasi Cabang{width==="xs"?<br/>:null}
                <Button style={{float:"right"}} variant="contained" color={editBranchInformation?"secondary":"primary"} disabled={savingBranchInformation} onClick={editBranchInformation?()=>saveBranchInformation():()=>setEditBranchInformation(true)} >{editBranchInformation?"Simpan":"Ubah"}</Button>
                {editBranchInformation&&<Button style={{float:"right",marginRight:"5px"}} variant="outlined" color="primary" disabled={savingBranchInformation} onClick={revertBranchInformation} >Batal</Button>}
              </Typography>
              <TextField
                id="branchName"
                label="Nama Cabang"
                placeholder=""
                required
                disabled={!editBranchInformation}
                fullWidth={true}
                defaultValue={activeBranch.name}
                style={{margin:"5px"}}
              />
              <TextField
                id="branchAddress"
                label="Alamat"
                placeholder=""
                required
                disabled={!editBranchInformation}
                fullWidth={true}
                defaultValue={activeBranch.address}
                style={{margin:"5px"}}
              />
              <TextField
                id="branchTown"
                label="Kota"
                placeholder=""
                required
                disabled={!editBranchInformation}
                fullWidth={true}
                defaultValue={activeBranch.town}
                style={{margin:"5px"}}
              />
              <TextField
                id="branchPhone"
                label="Nomor Telepon"
                placeholder=""
                required
                disabled={!editBranchInformation}
                fullWidth={true}
                defaultValue={activeBranch.phone}
                style={{margin:"5px"}}
              />
              <TextField
                id="branchEmail"
                label="Email"
                placeholder=""
                required
                disabled={!editBranchInformation}
                fullWidth={true}
                defaultValue={activeBranch.email}
                style={{margin:"5px"}}
              />
              <TextField
                id="branchNPWP"
                label="NPWP"
                placeholder=""
                disabled={!editBranchInformation}
                fullWidth={true}
                defaultValue={activeBranch.NPWP}
                style={{margin:"5px"}}
              />  
            </Paper>
          </Grid>
          
          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"100px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Fitur{width==="xs"?<br/>:null}
              </Typography>
              <List >
                {(activeCompany.type!=="Finance"&&activeCompany.type!=="Market"&&activeCompany.type!=="Production"&&activeCompany.type!=="Workshop"&&activeCompany.type!=="Restaurant"
                )&&<Typography variant="subtitle1">Tidak ada fitur</Typography>}

                {(activeCompany.type==="Finance"||activeCompany.type==="Market"||activeCompany.type==="Production"||activeCompany.type==="Workshop"||activeCompany.type==="Restaurant"
                )&&
                  <ListItem>
                    <ListItemIcon>
                      <AttachMoneyIcon />
                    </ListItemIcon>
                    <ListItemText id="financeConfig" primary="Finance" />
                    <ListItemSecondaryAction>
                      <Switch
                        edge="end"
                        onChange={toggleFinanceFeature}
                        checked={!!financeConfig&&financeConfig.enabled}
                        inputProps={{ 'aria-labelledby': 'financeConfig' }}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                }
                {(activeCompany.type==="Market"||activeCompany.type==="Production"||activeCompany.type==="Workshop"||activeCompany.type==="Restaurant"
                )&&
                  <ListItem>
                    <ListItemIcon>
                      <ShoppingCartIcon />
                    </ListItemIcon>
                    <ListItemText id="market" primary="Market" />
                    <ListItemSecondaryAction>
                      <Switch
                        edge="end"
                        onChange={toggleMarketFeature}
                        disabled={!financeConfig||(!!financeConfig&&!financeConfig.enabled)}
                        checked={!!marketConfig&&marketConfig.enabled}
                        inputProps={{ 'aria-labelledby': 'market' }}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                }
                {(activeCompany.type==="Production"
                )&&
                  <ListItem>
                    <ListItemIcon>
                      <LocationCityIcon />
                    </ListItemIcon>
                    <ListItemText id="production" primary="Production" />
                    <ListItemSecondaryAction>
                      <Switch
                        edge="end"
                        onChange={toggleProductionFeature}
                        disabled={(!financeConfig||(!!financeConfig&&!financeConfig.enabled)||
                          (!marketConfig||(!!marketConfig&&!marketConfig.enabled)))}
                        checked={!!productionConfig&&productionConfig.enabled}
                        inputProps={{ 'aria-labelledby': 'production' }}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                }
                {(activeCompany.type==="Workshop"
                )&&
                  <ListItem>
                    <ListItemIcon>
                      <BuildIcon />
                    </ListItemIcon>
                    <ListItemText id="workshop" primary="Workshop" />
                    <ListItemSecondaryAction>
                      <Switch
                        edge="end"
                        onChange={toggleWorkshopFeature}
                        disabled={(!financeConfig||(!!financeConfig&&!financeConfig.enabled)||
                          (!marketConfig||(!!marketConfig&&!marketConfig.enabled)))}
                        checked={!!workshopConfig&&workshopConfig.enabled}
                        inputProps={{ 'aria-labelledby': 'workshop' }}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                }
                {(activeCompany.type==="Restaurant"
                )&&
                  <ListItem>
                    <ListItemIcon>
                      <RestaurantMenuIcon />
                    </ListItemIcon>
                    <ListItemText id="restaurant" primary="Restaurant" />
                    <ListItemSecondaryAction>
                      <Switch
                        edge="end"
                        onChange={toggleRestaurantFeature}
                        disabled={(!financeConfig||(!!financeConfig&&!financeConfig.enabled)||
                          (!marketConfig||(!!marketConfig&&!marketConfig.enabled)))}
                        checked={!!restaurantConfig&&restaurantConfig.enabled}
                        inputProps={{ 'aria-labelledby': 'restaurant' }}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                }
              </List>
            </Paper>
          </Grid>

          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"100px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Deaktivasi
                <IconButton
                  edge="end"
                  aria-label="delete"
                  style={{float:"right"}}
                  color={activeBranch.deactivated?"default":"primary"}
                  onClick={()=>toogleBranchEnabled(activeCompany,activeBranch)}>
                  {activeBranch.deactivated?<NotInterestedIcon />:<PowerSettingsNewIcon/>}
                </IconButton>
              </Typography>
              <Typography variant="subtitle1">
                Status Cabang : {activeBranch.deactivated?"NON AKTIF":"AKTIF"}
              </Typography>
            </Paper>
          </Grid>

        </Grid>
      }
    </div>
  )
}

const condition = authUser => !!authUser;
export default withAuthDomain(condition,false,"online-asset-manager","")(withWidth()(BranchSettingsPage));